import React, {useState} from "react";
import {useCustomer} from "context/customer/customerContext";
import {useNavigate} from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import { Grid, Paper, Typography, Button, Box, Dialog, DialogContent, IconButton } from "@mui/material";
import SideBar from "../../../components/dealer/Inspection/SideBar";
import StreetGlide from "../../../assets/2017-HARLEY-DAVIDSON-ROAD-KING.jpg";
import {WearAndTearSquare} from "./styles";
import wear_and_tear from "assets/wear_tear_square.png";
import {useIsMobile} from "../../../hooks/useIsMobile";

/**
 *
 */
function Introduction() {
  const [open, setOpen] = useState(false);

  // Handlers for opening and closing the modal
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const {customerDetails} = useCustomer();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="start" sx={{
      margin: "25px 0",
      width: {
        xs: "calc(100% - 16px)", // Full width on mobile
        sm: "calc(100% + 16px)", // Retain the extra 16px for larger screens
      },
    }}>
      <Grid item xs={12} md={4}>
        <SideBar unit={{
          year: customerDetails?.year || "N/A",
          make: customerDetails?.brand || "N/A",
          model: customerDetails?.model || "N/A",
          vin: customerDetails?.vin || "N/A",
        }} />
      </Grid>
      <Grid item xs={12} md={8} >
        <Paper
          elevation={3}
          sx={{
            padding: { xs: 2, md: 4 }, // Responsive padding for small and medium screens
            margin: "0 0",
            lineHeight: 1.6,
          }}
        >
          <Typography variant="h5" gutterBottom>
            Introduction
          </Typography>

          <Typography variant="body1" paragraph>
            Before you begin, please ensure you are prepared to spend about 15 to 30 minutes for this process.
            It’s important that you are in front of your motorcycle, as you will need direct access to various
            parts of your vehicle during the inspection.
          </Typography>

          <Typography variant="h6" sx={{ marginTop: 3, marginBottom: 2 }}>
            Here’s what you need to know to get started:
          </Typography>

          {/* Key points list */}
          <Typography variant="body1" paragraph sx={{ marginBottom: 2 }}>
            1. <strong>Set Aside Time:</strong> Allocate between 15 to 30 minutes where you won&#39;t be interrupted.
            This will ensure that you can perform a thorough and unhurried inspection.
          </Typography>

          <Typography variant="body1" paragraph sx={{ marginBottom: 2 }}>
            2. <strong>Be Vehicle-Ready:</strong> Please be physically present in front of your motorcycle. You’ll
            need to check different components and systems, so easy access is crucial.
          </Typography>

          <Typography variant="body1" paragraph sx={{ marginBottom: 2 }}>
            3. <strong>Tools and Equipment:</strong> If possible, have any basic tools and a flashlight handy, as
            you might need them to check certain areas more closely.
          </Typography>

          <Typography variant="body1" paragraph sx={{ marginBottom: 2 }}>
            4. <strong>Safety First:</strong> Ensure your motorcycle is securely parked and in a stable position to
            prevent any movement during the inspection.
          </Typography>

          <Typography variant="body1" paragraph sx={{ marginBottom: 2 }}>
            5. <strong>Document Findings:</strong> Have a notepad or a digital device ready if you wish to take notes
            or record any issues you might find during the inspection.
          </Typography>

          {/* Centered Image */}
          {/* Centered Image with Click Handler */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              my: 4,
            }}
          >
            {/* Clickable Image */}
            <Box component="span" onClick={handleClickOpen} sx={{ cursor: "pointer" }}>
              <WearAndTearSquare src={wear_and_tear} style={{ maxWidth: "400px", width: '100%' }} />
            </Box>
          </Box>

          {/* Dialog for Enlarged Image */}
          <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="lg"
          >
            <DialogContent>
              {/* Close Button */}
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>

              {/* Enlarged Image */}
              <img
                src={wear_and_tear}
                alt="Wear and Tear"
                style={{ width: "100%", height: "auto" }}
              />
            </DialogContent>
          </Dialog>

          {/* Button Section */}
          <Box textAlign="center">
            <Button
              variant="contained"
              color="secondary"
              sx={{ marginTop: 2, paddingX: 4 }} // Add horizontal padding to button for better appearance
              onClick={() => navigate("/customer/condition")}
            >
              I Understand
            </Button>
          </Box>
        </Paper>
      </Grid>

    </Grid>
  );
}

export default Introduction;
